import React, { useEffect, useState } from "react";
import { Paper, Typography, Box, CircularProgress } from "@mui/material";
import Grid from "./utils/CompatGrid";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import DesignServicesIcon from "@mui/icons-material/DesignServices";
import PrintIcon from "@mui/icons-material/Print";
import HistoryIcon from "@mui/icons-material/History";
import { getProducts, getTemplates, getLabelHistory, getPrintHistory } from "./api/labelStudioApi";

const StatCard = ({ icon, label, value, color }) => (
  <Paper elevation={2} sx={{ p: 3, display: "flex", alignItems: "center", gap: 2, borderRadius: 3 }}>
    <Box
      sx={{
        width: 56,
        height: 56,
        borderRadius: 2,
        bgcolor: `${color}20`,
        color,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {icon}
    </Box>
    <Box>
      <Typography variant="h5" fontWeight={700}>
        {value}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {label}
      </Typography>
    </Box>
  </Paper>
);

const Dashboard = () => {
  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState({ products: 0, templates: 0, labels: 0, prints: 0 });

  useEffect(() => {
    const load = async () => {
      try {
        const [products, templates, labels, prints] = await Promise.all([
          getProducts().catch(() => []),
          getTemplates().catch(() => []),
          getLabelHistory().catch(() => []),
          getPrintHistory().catch(() => []),
        ]);
        setStats({
          products: products.length,
          templates: templates.length,
          labels: labels.length,
          prints: prints.length,
        });
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box>
      <Typography variant="h5" fontWeight={700} sx={{ mb: 3 }}>
        Dashboard
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard icon={<Inventory2Icon />} label="Products" value={stats.products} color="#0aad0a" />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard icon={<DesignServicesIcon />} label="Label Templates" value={stats.templates} color="#2196f3" />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard icon={<PrintIcon />} label="Labels Generated" value={stats.labels} color="#ff9800" />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard icon={<HistoryIcon />} label="Print Jobs" value={stats.prints} color="#9c27b0" />
        </Grid>
      </Grid>

      <Paper elevation={1} sx={{ p: 3, mt: 4, borderRadius: 3 }}>
        <Typography variant="h6" fontWeight={600} gutterBottom>
          How it works
        </Typography>
        <Typography variant="body2" color="text.secondary">
          1. Create Product &rarr; 2. Create Label Template (one time) &rarr; 3. Save Template &rarr; 4. Select
          Product on Generate Labels &rarr; 5. Auto-fill Product Data &rarr; 6. Preview &rarr; 7. Print / Export PDF.
        </Typography>
      </Paper>
    </Box>
  );
};

export default Dashboard;
